import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/client';
import { useWebSocket } from '../../api/websocket';

export default function JinglesList() {
  const [jingles, setJingles] = useState([]);
  const [loading, setLoading] = useState(true);
  const { lastMessage } = useWebSocket('/ws/jingles');

  useEffect(() => {
    loadJingles();
  }, [lastMessage]);

  async function loadJingles() {
    try {
      const res = await api.get('/api/jingles');
      setJingles(res.data);
    } catch (err) {
      console.error('Failed to load jingles', err);
    } finally {
      setLoading(false);
    }
  }

  const toggleActive = async (id) => {
    try {
      await api.put(`/api/jingles/${id}/toggle`);
      loadJingles();
    } catch (err) {
      console.error('Failed to toggle jingle', err);
    }
  };

  if (loading) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6">
      <div className="mb-6 flex items-center justify-between">
        <h1 className="text-2xl font-bold text-dark-100">Jingles</h1>
        <Link to="/jingles/create" className="btn btn-primary">Add New</Link>
      </div>
      <div className="table-wrapper">
        <table className="table">
          <thead>
            <tr>
              <th>Name</th><th>Trigger</th><th>Trigger Value</th><th>Priority</th><th>Status</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {jingles.map(j => (
              <tr key={j.id}>
                <td>{j.name}</td>
                <td>{j.trigger_type}</td>
                <td>{j.trigger_value || '-'}</td>
                <td>{j.priority}</td>
                <td>
                  <span className={`badge ${j.is_active ? 'badge-success' : 'badge-neutral'}`}>
                    {j.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>
                  <button
                    onClick={() => toggleActive(j.id)}
                    className="btn btn-sm btn-outline"
                  >
                    {j.is_active ? 'Deactivate' : 'Activate'}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
